import { MailHtmlIframe } from "../microsoft/MailHtmlIframe";

/**
 * Render a mail body with the company Microsoft Innhold iframe.
 * Pass Graph `body_content` when available — do not pre-sanitize.
 */
export function CaseEmailHtmlBody({ html, text, title, emptyLabel, iframeClassName }) {
  return (
    <MailHtmlIframe
      html={html}
      text={text}
      title={title}
      emptyLabel={emptyLabel}
      iframeClassName={iframeClassName}
    />
  );
}
